import { Entity } from '@/store/shared/entity'

export default class Tenant extends Entity<number>{
    tenancyName:string;
    name:string;
    isActive:boolean;
    adminEmailAddress?:string;
    connectionString?:string;    
    size?:number;
}